import { dialogClose } from "@/modules/MuiDialog"
import { Box, Button, CardHeader, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"

const TaxInfoDialog = () => {
    return (
        <>
            <DialogTitle sx={{ typography: 'h2' }}><b>사업자 미신고시 세금관련 안내</b></DialogTitle>
            <DialogContent>
                <Typography gutterBottom sx={{ mb: 2 }}>
                    사업자 등록없이 지속적으로 판매하는 경우, 가산세 부담 등의 불이익을 받을 수 있습니다. <br />
                    플랫폼 정보 및 추천 벤더의 정보를 사용하는 것은 일시적으로 허용되는 정책이나, 판매 활동을 계속하실 경우 
                    사업자 등록 및 통신판매신고를 진행하여 주시기를 권장합니다.
                </Typography>
                <Typography variant="body" color="red">
                    사업자 등록없이 지속적으로 물품을 판매할 경우, 다음과 같은 불이익을 받으실 수 있음을 알려드립니다.
                </Typography>
                <Box bgcolor={'#eee'} sx={{ p: 2, mt: 2 }}>
                    <Typography variant="body2" gutterBottom>
                        <b>1. 사업자등록 없이 이루어진 거래에 대하여 공급가액의 1% (간이과세자는 공급대가의 0.5%) 미등록 가산세 부담</b>
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        <b>2. 사업자등록 없이 사업을 영위하는 경우, 세금계산서의 교부가 불가능하며 관련 매입세액을 공제받을 수 없음</b>
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        <b>3. 사업자등록을 하지 아니하여 부가가치세를 신고하지 못한 사업장의 거래에 대하여는 신고불성실 가산세와 납부불성실 가산세 추가 부담</b>
                    </Typography>
                    <Typography variant="caption" gutterBottom>
                        * 신고불성실 가산세: 무신고, 과소신고의 경우 신고하지 아니한 납부세액의 10% 가산세 부담 <br/>
                    </Typography>
                    <Typography variant="caption" gutterBottom>
                        * 납부불성실 가산세: 무납부, 과소납부의 경우 미납부 또는 과소 납부세액의 1일 0.03%(연간 10.95%)의 가산세 부담
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        <b>4. 소득세를 신고하지 않은 경우 신고불성실 가산세와 납부불성실 가산세 추가부담 (주민세 별도 10%)</b>
                    </Typography>
                    <Typography variant="caption" gutterBottom>
                        *신고불성실 가산세: 산출세액에서 무신고나 과소신고 해당 비율에 대하여 20% 가산세 부담 <br/>
                    </Typography>
                    <Typography variant="caption" gutterBottom>
                        *납부불성실 가산세: 무납부, 과소납부의 경우 미납부 또는 과소 납부세액의 1일 0.03%(연간 10.95%)의 가산세 부담
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        <b>상기 불이익 이외에 조세범처벌법 등 관련법규에 따라 처벌 될 수 있습니다.</b>
                    </Typography>
                </Box>
                <Typography variant="body2">
                    사업자 등록은 사업 개시 후, 즉 개인판매자 가입 후 20일 이내에 사업장 소재지 관할 세무서에서 신청하실 수 있습니다.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { dialogClose() }} variant="outlined" size="large" color="black">닫기</Button>
            </DialogActions>
        </>
    )
}
export default TaxInfoDialog